import { render, staticRenderFns } from "./PayerMappingList.vue?vue&type=template&id=24bf91a7&scoped=true"
import script from "./PayerMappingList.vue?vue&type=script&lang=js"
export * from "./PayerMappingList.vue?vue&type=script&lang=js"
import style0 from "./PayerMappingList.vue?vue&type=style&index=0&id=24bf91a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf91a7",
  null
  
)

export default component.exports